.button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: var(--font-size-default);
  gap: 0.5rem;
  height: 2.75rem;
  justify-content: center;
  line-height: inherit;
  margin: 0;
  padding: 0.75rem 1rem;
  transition: var(--transition-colors);
  white-space: nowrap;
}

.button[href] {
  text-decoration: none;
}

.button:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.button:hover {
  background-color: var(--color-grey-300);
  outline: 0;
}

.button--blank,
.button--blank-subtle,
.button--blank-icon {
  border: 0;
  border-radius: 0;
  gap: 0;
  height: auto;
  padding: 0;
  text-decoration: underline;
  vertical-align: middle;
}

.button--blank,
.button--blank-icon {
  color: var(--color-uva-black);
}

.button--blank-subtle {
  color: var(--color-grey-700);
}

.button--blank-icon {
  border: 1px solid transparent;
  border-radius: 0.5rem;
  height: 2.5rem;
  width: 2.5rem;
}

.button--blank:focus,
.button--blank:not([disabled]):hover {
  background: none;
  text-decoration: underline;
}

.button--blank-subtle:focus,
.button--blank-subtle:not([disabled]):hover {
  background: none;
  color: var(--color-uva-black);
  text-decoration: underline;
}

.button--blank-icon:focus,
.button--blank-icon:not([disabled]):hover {
  background-color: var(--color-grey-300);
  border-color: var(--color-grey-600);
}

.button--primary {
  background-color: var(--color-uva-black);
  border-color: var(--color-uva-black);
  color: var(--color-uva-white);
}

.button--primary:hover {
  background-color: var(--color-grey-700);
  border-color: var(--color-grey-700);
}

.button--primary[disabled] {
  background-color: var(--color-uva-black);
  color: var(--color-uva-white);
}

.button--secondary {
  background-color: transparent;
  border-color: var(--color-uva-black);
  color: var(--color-uva-black);
}

.button--secondary:hover {
  background-color: var(--color-uva-black);
  color: var(--color-uva-white);
}

.button--secondary[disabled] {
  background-color: transparent;
  color: var(--color-uva-black);
}

.button--destructive-primary {
  background-color: var(--color-red-600);
  border-color: var(--color-red-600);
  color: var(--color-uva-white);
}

.button--destructive-primary:hover {
  background-color: var(--color-red-800);
  border-color: var(--color-red-800);
  color: var(--color-uva-white);
}

.button--destructive-primary[disabled] {
  background-color: var(--color-red-600);
  border-color: var(--color-red-600);
  color: var(--color-uva-white);
}

.button--destructive-secondary {
  background-color: var(--color-uva-white);
  border-color: var(--color-red-600);
  color: var(--color-red-600);
}

.button--destructive-secondary:hover {
  background-color: var(--color-red-600);
  border-color: var(--color-red-600);
  color: var(--color-uva-white);
}

.button--destructive-secondary[disabled] {
  background-color: var(--color-uva-white);
  border-color: var(--color-red-600);
  color: var(--color-red-600);
}

.button--destructive-secondary-transparent {
  background-color: transparent;
  border-color: var(--color-red-600);
  color: var(--color-red-600);
}

.button--destructive-secondary-transparent:hover {
  background-color: var(--color-red-600);
  border-color: var(--color-red-600);
  color: var(--color-uva-white);
}

.button--destructive-secondary-transparent[disabled] {
  background-color: transparent;
  border-color: var(--color-grey-700);
  color: var(--color-grey-700);
}

.button--wide-column {
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-text-non-essential);
  gap: 0.25rem;
  height: unset;
  padding: 0.5rem 0.25rem;
  width: 100%;
}

/*
  A disabled button trumps all and does not distinguish between
  primary/secondary/destructive appearances in any form
*/

.button[disabled] {
  cursor: unset;
  opacity: 0.4;
  text-decoration: none;
  transition-delay: 250ms;
  /* avoid always flickering to gray */
}
